import { createVNode } from "vue";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getOptionProps } from '../_util/props-util';

var Col = function Col(_, _ref) {
  var _ref2;

  var attrs = _ref.attrs;
  var _attrs$child = attrs.child,
      child = _attrs$child === void 0 ? {} : _attrs$child,
      bordered = attrs.bordered,
      colon = attrs.colon,
      type = attrs.type,
      layout = attrs.layout,
      key = attrs.colKey;

  var _getOptionProps = getOptionProps(child),
      prefixCls = _getOptionProps.prefixCls,
      _getOptionProps$span = _getOptionProps.span,
      span = _getOptionProps$span === void 0 ? 1 : _getOptionProps$span;

  var _child$children = child.children,
      children = _child$children === void 0 ? {} : _child$children,
      _child$props = child.props,
      props = _child$props === void 0 ? {} : _child$props;
  var label = props.label || children.label && children.label();
  var defaultSlot = children.default && children.default();
  var labelProps = {
    class: ["".concat(prefixCls, "-item-label"), (_ref2 = {}, _defineProperty(_ref2, "".concat(prefixCls, "-item-colon"), colon), _defineProperty(_ref2, "".concat(prefixCls, "-item-no-label"), !label), _ref2)],
    key: "".concat(key, "-label")
  };

  if (layout === 'vertical') {
    labelProps.colspan = span * 2 - 1;
  }

  if (bordered) {
    if (type === 'label') {
      return createVNode("th", labelProps, [label]);
    }

    return createVNode("td", {
      "class": "".concat(prefixCls, "-item-content"),
      "key": "".concat(key, "-content"),
      "colspan": span * 2 - 1
    }, [defaultSlot]);
  }

  if (layout === 'vertical') {
    if (type === 'content') {
      return createVNode("td", {
        "colspan": span,
        "class": "".concat(prefixCls, "-item")
      }, [createVNode("span", {
        "class": "".concat(prefixCls, "-item-content"),
        "key": "".concat(key, "-content")
      }, [defaultSlot])]);
    }

    return createVNode("td", {
      "colspan": span,
      "class": "".concat(prefixCls, "-item")
    }, [createVNode("span", {
      "class": ["".concat(prefixCls, "-item-label"), _defineProperty({}, "".concat(prefixCls, "-item-colon"), colon)],
      "key": "".concat(key, "-label")
    }, [label])]);
  }

  return createVNode("td", {
    "colspan": span,
    "class": "".concat(prefixCls, "-item")
  }, [createVNode("span", labelProps, [label]), createVNode("span", {
    "class": "".concat(prefixCls, "-item-content"),
    "key": "".concat(key, "-content")
  }, [defaultSlot])]);
};

export default Col;